/*
Replace
dish with your resource Name :) Take care about different writings!
/!\ Dish dish Dishes dishes /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";
import { getRecipeAttributes } from "../recipes";

export const dishSlice = createSlice({
  name: "dishes",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listDishes,
  show: showDish,
  create: createDish,
  update: updateDish,
} = dishSlice.actions;

export const actions = dishSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const dishes = (state) =>
  state.dishes.idsList.map((id) => state.dishes.dictionary[id]);
export const dish = (state) =>
  state.dishes.showId && state.dishes.dictionary[state.dishes.showId];
export const dishAttributes = (state) => dish(state)?.attributes;
export const dishRelationships = (state) => dish(state)?.relationships;
export const dishId = (state) => state.dishes.showId;

export const getDish = createSelector(
  (state) => state.dishes.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getDishAttributes = createSelector(
  (state) => state.dishes.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getDishRelationships = createSelector(
  (state) => state.dishes.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getDishAttributesExpanded = createSelector(
  (state, id) => getDish(state, id),
  (state, id) => {
    const relationships = getDishRelationships(state, id);
    if (relationships) {
      return {
        main_recipe: getRecipeAttributes(
          state,
          relationships.main_recipe.data.id
        ),
        topping_1: getRecipeAttributes(
          state,
          relationships.topping_1?.data?.id
        ),
        topping_2: getRecipeAttributes(
          state,
          relationships.topping_2?.data?.id
        ),
      };
    }
  },
  (dish, relatedAttributes) =>
    dish && relatedAttributes && { ...dish.attributes, ...relatedAttributes }
);

export const getDishes = createSelector(
  (state) => state.dishes.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export const getDishIdsForDate = createSelector(
  (state) => state.dishes.dictionary,
  (_, day) => day,
  (dictionary, day) => {
    return Object.entries(dictionary)
      .filter((_dish) => _dish[1].attributes.date_of_serving === day)
      .map((_dish) => _dish[0]);
  }
);

export const getDishIdsForDateAndTimeslot = createSelector(
  (state) => state.dishes.dictionary,
  (_, singleDayId) => singleDayId,
  (_, timeslotId) => timeslotId,
  (dictionary, { singleDayId, timeslotId }) => {
    return Object.entries(dictionary)
      .filter(
        (_dish) =>
          _dish[1].attributes.date_of_serving === singleDayId &&
          _dish[1].relationships.timeslot.data.id === timeslotId
      )
      .map((_dish) => _dish[0]);
  }
);

export const getOriginDishesFromCounterAndMenuDishIds = createSelector(
  (state) => state.dishes.dictionary,
  (state) => state.menuDishes.dictionary,
  (_, counterId) => counterId,
  (_, menuDishIds) => menuDishIds,
  (dishesDictionary, menuDishesDictionary, { counterId, menuDishIds }) => {
    const dishIds = Object.entries(menuDishesDictionary)
      .filter(
        (menuDish) =>
          // menuDishIds.includes(parseInt(menuDish[0])) &&
          menuDish[1]?.relationships?.counter?.data?.id === counterId
      )
      ?.map((menuDish) => menuDish[1]?.relationships?.dish?.data?.id);

    let originDishes = Object.entries(dishesDictionary).filter(
      (dish) => dish[1]?.attributes?.is_origin && dishIds?.includes(dish[0])
    );

    if (!originDishes) {
      originDishes = Object.entries(dishesDictionary).filter((dish) =>
        dishIds?.includes(dish[0])
      );
    }

    return originDishes.map((dish) => dish[1]);
  }
);

export default dishSlice.reducer;
